export const SERVER_ERROR_TYPES = {
  FAILED_TO_REFRESH_TOKEN: "FAILED_TO_REFRESH_TOKEN",
  UNAUTHORIZED: "UNAUTHORIZED",
  UNKNOWN: "UNKNOWN",
  UPDATE_VERSION: "UPDATE_VERSION",
  GLOBAL_LAYOUT_DISABLED: "GLOBAL_LAYOUT_DISABLED",
  GLOBAL_LAYOUT_AMBIGUOUS_ROUTING: "GLOBAL_LAYOUT_AMBIGUOUS_ROUTING",
  MERGED_USER_CANNOT_ACTIVATE: "MERGED_USER_CANNOT_ACTIVATE",
  // Refusing to delete an extension's metadata while a Browser Controls policy still
  // names its id — the row would survive via the policy with nothing left to render.
  // `data` carries the blocking policy names.
  EXTENSION_IN_USE_BY_POLICY: "EXTENSION_IN_USE_BY_POLICY",
  // Refusing to seed desktop-parity Access Policies over an org that already has some:
  // overwriting an access posture on a button press is not recoverable from the UI, and
  // merging into an ordered rule set would quietly change what the existing rules match.
  BROWSER_POLICIES_ALREADY_EXIST: "BROWSER_POLICIES_ALREADY_EXIST",
};
